module.exports = __webpack_public_path__ + "static/TroisMilleBoldItalic-18-60617d730a3333835ad6cc3caf1f2c49.woff";